// Configuration file for KPCA application

const config = {
  // API Configuration
  API_URL: 'https://hive.kpca.or.ke/api/',
  
};

// Export the configuration
export default config; 